import { render, staticRenderFns } from "./PaisAdicionar.vue?vue&type=template&id=6d4b50ea"
import script from "./PaisAdicionar.vue?vue&type=script&lang=js"
export * from "./PaisAdicionar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports